import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import FloatingInput from "../common/FloatingInput";
import CensusHistory from "./CensusHistory";
import CensusClone from "./CensusClone";
import { toast } from "react-toastify";
import { censusBillingRules, programUnitsModality } from "../services/soar";

function CensusRule(props) {
  const { ruleId } = useParams();
  const [rule, setRule] = useState({});
  const [setupData, setSetupData] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [copyOpen, setCopyOpen] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [publishDate, setPublishDate] = useState(null);
  const [data, setData] = useState({});
  const navigate = useNavigate();
  const applicationId =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
      : "58990f83-8566-4ba8-b4b5-584a64e4cba1";

  const invoices = [
    { _id: "SafySummary", name: "SAFY Summary" },
    { _id: "SAFYItemized", name: "SAFY Itemized" },
    { _id: "AlabamaDHR", name: "Alabama DHR" },
  ];

  useEffect(() => {
    getRule();
    // getSetupData();
  }, [ruleId]);

  const getRule = async () => {
    try {
      //get all rule history based on the id of the rule
      const response = await censusBillingRules({
        command: "query",
        application: applicationId,
        keyword: "searchbyid",
        ids: [ruleId],
      });
      const details = await getModalities(response.data);
      // console.log("Setting details", details);
      setRule(details);
    } catch (error) {
      toast.error("Error fetching rules:", error);
    }
  };

  // const getSetupData = async () => {
  //   const payorResponse = await getCensusPayors();
  //   const groupPlansResponse = await censusGroupPlanAction({
  //     command: "query",
  //     keyword: "viewall",
  //     application: applicationId,
  //   });
  //   const serviceConfigResponse = await censusServiceConfigs({
  //     command: "query",
  //     application: applicationId,
  //     keyword: "viewall",
  //   });
  //   const programUnitResponse = await programUnitConfigs({
  //     command: "query",
  //     environment: "SOARQueryLive",
  //     keyword: "viewall",
  //   });
  //   console.log("Setup Data Use Effect");
  //   setSetupData({
  //     ...setupData,
  //     payors: payorResponse
  //       .filter((payor) => payor.active)
  //       .map((payor) => ({
  //         _id: payor.id,
  //         name: payor.name,
  //       }))
  //       .sort((a, b) => a.name.localeCompare(b.name)),
  //     groupPlans: groupPlansResponse.data
  //       .filter((groupPlan) => groupPlan.active)
  //       .map((groupPlan) => ({
  //         _id: groupPlan.id,
  //         name: groupPlan.name,
  //         payorId: groupPlan.payorId,
  //       }))
  //       .sort((a, b) => a.name.localeCompare(b.name)),
  //     serviceConfigurations: serviceConfigResponse.data
  //       .filter((serviceConfig) => serviceConfig.active)
  //       .map((serviceConfig) => ({
  //         _id: serviceConfig.id,
  //         name: serviceConfig.name,
  //         serviceId: serviceConfig.serviceId,
  //         config: serviceConfig.configuration,
  //       }))
  //       .sort((a, b) => a.name.localeCompare(b.name)),
  //     programUnits: programUnitResponse.data
  //       .map((programUnit) => ({
  //         _id: programUnit.ccx_unitid,
  //         name: programUnit.ccx_name,
  //       }))
  //       .sort((a, b) => a.name.localeCompare(b.name)),
  //   });
  // };

  const getModalities = async (r) => {
    // console.log("Get Modalities for ", r)

    if (r) {
      // Ensure r is an array
      if (!Array.isArray(r)) {
        r = [r];
      }
      //get the rule by ruleId from the rule history
      const br = r.find((item) => item.id === ruleId);
      //get program units from the rule
      const unitIds = br.serviceConfigurationValue.programUnits.map(
        (unit) => unit._id
      );
      //get all the modalities for the list of program units
      const modalitiesResponse = await programUnitsModality({
        command: "query",
        application: applicationId,
        environment:
          process.env.REACT_APP_ENVIRONMENT === "Production"
            ? "SOARQueryLive"
            : "SOARQueryBase",
        keyword: "byprogram",
        ids: unitIds,
        searchTerms: { searchDate: new Date().toISOString() },
      });

      //set setupData with modalities and rule history
      setSetupData({
        ...setupData,
        modalities: modalitiesResponse.data
          .slice()
          .sort((a, b) =>
            a.sor_caremodality.name.localeCompare(b.sor_caremodality.name)
          )
          .map((modality) => modality.sor_caremodality.name),
        ruleHistory: r.filter((item) => item.active),
      });

      const currentBillingRule = br.configuration?.modalities
        ? { ...br }
        : { ...br, configuration: { modalities: [] } };

      const tiers = br.configuration?.fpTiers ? br.configuration.fpTiers : 1;

      //need to rework ages to be configurable inside each selected modality
      //
      // const ages = br.configuration?.ageRanges
      //   ? br.configuration.ageRanges
      //   : [{ min: "", max: "" }];

      const serviceStatuses =
        br.serviceConfigurationValue?.serviceStatuses || [];

      //for each modality returned
      await modalitiesResponse.data.forEach((modality) => {
        const modalityName = modality.sor_caremodality.name;
        //check to see if modality does not exist in existing rule configuration
        if (
          !currentBillingRule.configuration.modalities.some(
            (item) => item.name === modalityName
          )
        ) {
          currentBillingRule.configuration.modalities.push({
            name: modalityName,
            id: `${br.serviceConfigurationName}-${modalityName}`,
          });
        }

        //get the modality in the Billing Rule Configuration
        const modalityConfig = currentBillingRule.configuration.modalities.find(
          (item) => item.name === modalityName
        );

        //NEW AGES LOGIC
        if (!modalityConfig.ages) {
          modalityConfig.ages = [
            {
              min: "",
              max: "",
              invoice: "",
              billingCode: "",
              glCode: "",
              monthlyBilling: "",
            },
          ];
        }
        const ages = modalityConfig.ages;

        ages.forEach((range) => {
          serviceStatuses.forEach((ss) => {
            if (!range[ss]) {
              // console.log(`Adding ${ss} to modality ${modalityName}`);
              range[ss] =
                ss === "Unpaid Leave" ||
                ss === "Double Paid Respite" ||
                ss === "Unpaid Respite" ||
                ss === "Discharged"
                  ? "0.00"
                  : "";
            }
            if (currentBillingRule.serviceConfigurationValue.type === "TFC") {
            }
            for (let i = 1; i <= tiers; i++) {
              if (!range[`${ss}-tier${i}`]) {
                range[`${ss}-tier${i}`] =
                  ss === "Unpaid Leave" ||
                  ss === "Unpaid Respite" ||
                  ss === "Discharged"
                    ? "0.00"
                    : "";
              }
            }
          });
        });
      });

      // console.log("Returning Modalities", obj);
      return currentBillingRule;
    }
  };

  const saveRule = async (body) => {
    try {
      const response = await censusBillingRules(body);
      if (response.code === "success") {
        toast.success("Rule updated successfully!");
        //getRule();
        return response;
      } else {
        toast.error("Error updating rule:", response.message);
      }
    } catch (error) {
      toast.error("Error Updating rules:", error);
    }
  };

  const modBorder = (id) => {
    return id === data?.selected?.id
      ? "rounded border border-primary border-2 rounded bg-info text-dark p-2 pt-1 pb-3 mb-2"
      : "rounded border border-dark bg-secondary text-white p-2 pt-1 pb-3 mb-2 mt-0 ";
  };

  const handleAddAgeRange = () => {
    //console.log("Add Age Range Click", data.selected);
    if (
      (data.ageMin === 0 || parseInt(data.ageMin)) &&
      parseInt(data.ageMax) &&
      data.ageCalculation &&
      data.ageCalculation !== ""
    ) {
      const obj = { ...rule };

      const selectedModality = obj.configuration.modalities.find(
        (mod) => mod.name === data.selected.name
      );

      const newAgeRange = {
        min: parseInt(data.ageMin),
        max: parseInt(data.ageMax),
        calculation: data.ageCalculation,
        invoice: "",
        billingCode: "",
        glCode: "",
        monthlyBilling: "",
      };
      selectedModality.ages.push(newAgeRange);
      selectedModality.ages = selectedModality.ages.filter(
        (a) => a.min !== "" && a.max !== ""
      );
      setData({
        ...data,
        selected: selectedModality,
        ageMin: "",
        ageMax: "",
        ageCalculation: "",
      });
      setRule(obj);
      getModalities(obj);
    } else {
      toast.error(`Please enter a valid age range before adding`);
    }
  };

  const handleOnChange = async (newValue, ageRange, field) => {
    const obj = { ...rule };
    const modality = obj.configuration.modalities.find(
      (rm) => rm.id === data.selected?.id
    );
    if (modality) {
      const foundRange = modality.ages.find(
        (age) => age.min === ageRange.min && age.max === ageRange.max
      );

      if (foundRange) {
        foundRange[field] = newValue;
        // console.log(`Modality ageRange `, modality, foundRange);
      }
    }

    setRule(obj);
    setData({ ...data, selected: modality });
  };

  const handleOnDollarChange = async (newValue, ageRange, field) => {
    const obj = { ...rule };
    const modality = obj.configuration.modalities.find(
      (rm) => rm.id === data.selected?.id
    );
    if (modality) {
      const foundRange = modality.ages.find(
        (age) => age.min === ageRange.min && age.max === ageRange.max
      );

      if (foundRange) {
        foundRange[field] = parseFloat(newValue);
      }
    }

    setRule(obj);
    setData({ ...data, selected: modality });
  };

  const handleBlur = (newValue, ageRange, field) => {
    const obj = { ...rule };
    const modality = obj.configuration.modalities.find(
      (rm) => rm.id === data.selected?.id
    );
    if (modality) {
      const foundRange = modality.ages.find(
        (age) => age.min === ageRange.min && age.max === ageRange.max
      );
      if (foundRange) {
        const num = parseFloat(foundRange[field]);
        const cleanedNum = num.toFixed(2);
        foundRange[field] = cleanedNum;
      }
    }
    setRule(obj);
    setData({ ...data, selected: modality });
  };

  const getValue = (field, ageRange) => {
    return (
      rule.configuration.modalities
        .find((rm) => rm.id === data.selected?.id)
        ?.ages?.find(
          (age) => age.min === ageRange.min && age.max === ageRange.max
        )?.[field] || ""
    );
  };

  const getMonthlyBillingValue = (ageRange) => {
    return rule.configuration.modalities
      .find((rm) => rm.id === data.selected?.id)
      ?.ages.find((age) => age.min === ageRange.min && age.max === ageRange.max)
      ?.monthlyBilling;
  };

  const copyDown = (ageRange, column) => {
    const serviceStatuses =
      rule?.serviceConfigurationValue?.serviceStatuses || [];
    const obj = { ...rule };
    const modality = obj.configuration.modalities.find(
      (rm) => rm.id === data.selected?.id
    );
    if (modality) {
      const foundRange = modality.ages.find(
        (age) => age.min === ageRange.min && age.max === ageRange.max
      );
      if (foundRange) {
        if (column === "revenue") {
          const masterValue = foundRange[serviceStatuses[0]];
          serviceStatuses.forEach((ss) => {
            if (
              ss !== "UnPd Leave" &&
              ss !== "Dbl Pd Rsp" &&
              ss !== "UnPd Rsp" &&
              ss !== "Discharged"
            ) {
              handleOnChange(masterValue, foundRange, ss);
            }
          });
        } else {
          const masterValue = foundRange[`${serviceStatuses[0]}-${column}`];
          serviceStatuses.forEach((ss) => {
            if (
              ss !== "UnPd Leave" &&
              ss !== "UnPd Rsp" &&
              ss !== "Discharged"
            ) {
              handleOnChange(masterValue, foundRange, `${ss}-${column}`);
            }
          });
        }
      }
    }
    setRule(obj);
  };

  const checkComplete = (mod) => {
    const isComplete = mod.ages.every((age) => {
      const {
        min,
        max,
        calculation,
        invoice,
        billingCode,
        glCode,
        monthlyBilling,
        ...rest
      } = {
        ...age,
      };
      return !Object.values(rest).includes("");
    });

    return isComplete ? (
      <div className="rounded border border-dark bg-white float-end py-1 m-0">
        <i className="fas fa-circle-check fa-xl text-success p-1"></i>
      </div>
    ) : (
      <div className="rounded border border-dark bg-white float-end py-1">
        <i className="fas fa-circle-exclamation fa-xl text-danger p-1"></i>
      </div>
    );
  };

  const handleOnSave = async () => {
    await setRule({
      ...rule,
      configuration: {
        ...rule.configuration,
        ageMin: "",
        ageMax: "",
      },
    });
    await saveRule({
      command: "update",
      application: applicationId,
      id: rule.id,
      name: rule.name,
      type: rule.type,
      client: rule.clientId,
      clientName: rule.clientName,
      payor: rule.payorId,
      groupPlan: rule.groupPlanId,
      serviceConfiguration: rule.serviceConfigurationId,
      effective: rule.effective,
      expiration: rule.expiration,
      configuration: rule.configuration,
      keyword: "byid",
      ids: [ruleId],
    });
  };

  const handlePublish = async () => {
    const prevPublished = setupData.ruleHistory?.filter(
      (rh) =>
        rh.active === true &&
        rh.published === true &&
        (!rh.expiration || rh.expiration === "")
    );

    if (prevPublished.length > 1) {
      toast.error("More than 1 published rule exists. Cannot Publish");
      return;
    }
    if (prevPublished.length === 1) {
      const prevRule = prevPublished[0];

      if (new Date(publishDate) < new Date(prevRule.effective)) {
        toast.error(
          "Publish date cannot be before the previous rule's effective date."
        );
        return;
      }
      //expire prevRule one day before effective date
      const expireResponse = await saveRule({
        command: "expire",
        application: applicationId,
        id: prevRule.id,
        expiration: new Date(
          new Date(publishDate).setDate(new Date(publishDate).getDate() - 1)
        ).toISOString(),
      });

      if (expireResponse.code === "success") {
        toast.info("Previous rule expired successfully.");

        const updateEffectiveResponse = await saveRule({
          command: "update",
          application: applicationId,
          id: rule.id,
          name: rule.name,
          type: rule.type,
          client: rule.clientId,
          clientName: rule.clientName,
          payor: rule.payorId,
          groupPlan: rule.groupPlanId,
          serviceConfiguration: rule.serviceConfigurationId,
          effective: publishDate,
          expiration: "",
          configuration: rule.configuration,
          keyword: "byid",
          ids: [ruleId],
        });

        if (updateEffectiveResponse.code === "success") {
          const newPublishResponse = await saveRule({
            command: "publish",
            application: applicationId,
            id: rule.id,
          });

          if (newPublishResponse.code === "success") {
            toast.success("Current rule published successfully.");
          } else {
            toast.error(
              `Failed to publish current rule: ${newPublishResponse.message}`
            );
          }
        } else {
          toast.error(
            `Failed to update effective date: ${updateEffectiveResponse.message}`
          );
        }
      } else {
        toast.error(
          `Failed to expire existing rule: ${expireResponse.message}`
        );
      }
    }

    if (prevPublished.length === 0) {
      const updateEffectiveResponse = await saveRule({
        command: "update",
        application: applicationId,
        id: rule.id,
        name: rule.name,
        type: rule.type,
        client: rule.clientId,
        clientName: rule.clientName,
        payor: rule.payorId,
        groupPlan: rule.groupPlanId,
        serviceConfiguration: rule.serviceConfigurationId,
        effective: publishDate,
        expiration: "",
        configuration: rule.configuration,
        keyword: "byid",
        ids: [ruleId],
      });

      if (updateEffectiveResponse.code === "success") {
        const newPublishResponse = await saveRule({
          command: "publish",
          application: applicationId,
          id: rule.id,
        });
        if (newPublishResponse.code === "success") {
          toast.success("New rule published successfully.");
        } else {
          toast.error(
            `Failed to publish new rule: ${newPublishResponse.message}`
          );
        }
      } else {
        toast.error("Failed to update effective date.");
      }
    }

    getRule();
    setPublishDate(null);
    setModalOpen(false);
  };

  const editExistingRule = async () => {
    if (rule.draft) {
      toast.error("Draft rule cannot be edited.");
      return;
    }
    const draftResponse = await saveRule({
      command: "insert",
      application: applicationId,
      name: rule.name,
      client: rule.clientId,
      clientName: rule.clientName,
      type: rule.type,
      payor: rule.payorId,
      groupPlan: rule.groupPlanId,
      serviceConfiguration: rule.serviceConfigurationId,
      effective: "",
      expiration: "",
      configuration: rule.configuration,
    });

    if (draftResponse.code === "success") {
      toast.success("Draft rule created successfully.");
      navigate(`/rev/rules/${draftResponse.id}`);
    } else {
      toast.error("Failed to create draft rule.");
    }
  };

  const resetRule = async () => {
    const obj = {
      ...rule,
      configuration: {},
      fpTiers: 0,
    };
    await saveRule({
      command: "update",
      application: applicationId,
      id: obj.id,
      name: obj.name,
      type: obj.type,
      client: obj.clientId,
      clientName: obj.clientName,
      payor: obj.payorId,
      groupPlan: obj.groupPlanId,
      serviceConfiguration: obj.serviceConfigurationId,
      effective: "",
      expiration: "",
      configuration: {},
    });
    await getRule();
  };

  return (
    <div>
      <CensusClone
        show={copyOpen}
        setShow={() => setCopyOpen()}
        currentRule={rule}
        onClone={() => console.log("clone")}
      />
      <CensusHistory
        show={historyOpen}
        setShow={() => setHistoryOpen(false)}
        rule={rule}
        ruleHistory={setupData.ruleHistory}
      />
      <Modal
        show={modalOpen}
        onHide={() => setModalOpen(false)}
        animation={false}
        size="lg"
      >
        <Modal.Header closeButton className="bg-safy-info text-white">
          <Modal.Title>Group Plan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="h5 text-danger fw-bold mb-4">
            Make sure that all changes that are needed have been made.
            Publishing this Rule will create a snapshot of the previous values
            and publish the new values
          </div>
          <FloatingInput
            type="date"
            name="effectiveDate"
            label="Effective Date"
            value={publishDate}
            onChange={(e) => setPublishDate(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <div
            className="btn btn-danger"
            onClick={() => {
              setPublishDate(null);
              setModalOpen(false);
            }}
          >
            Close
          </div>
          <div
            className="btn btn-success"
            onClick={() => {
              handlePublish();
            }}
          >
            Publish
          </div>
        </Modal.Footer>
      </Modal>
      <div className="h4">Census Billing Rule</div>
      <div className="row">
        <div className="col-3">Effective: {rule.effective}</div>
        <div className="col-3">Expiration: {rule.expiration}</div>
        <div className="col-3">
          {rule.draft && (
            <div className="alert alert-warning border border-dark fw-bold">
              RULE IN DRAFT
            </div>
          )}
        </div>
        <div className="col-3">
          {rule.active &&
            rule.draft &&
            (!rule.expiration || rule.expiration === "") && (
              <div
                className="btn btn-primary float-end"
                role="button"
                onClick={() => setModalOpen(true)}
              >
                Publish
              </div>
            )}
          {rule.draft && (
            <div
              className="btn btn-success float-end mx-1"
              onClick={() => handleOnSave()}
            >
              Save
            </div>
          )}
          <div
            className="rounded border border-dark bg-warning p-1 mx-1 float-end"
            role="button"
            onClick={() => setHistoryOpen(true)}
          >
            <i className="fas fa-clock-rotate-left px-1"></i>
          </div>
          {/* <div
            className="btn btn-warning me-2 float-end"
            onClick={() => resetRule()}
          >
            Reset Rule
          </div> */}
          {!rule.draft &&
            (!rule.expiration || rule.expiration === "") &&
            setupData?.ruleHistory?.filter((rh) => rh.active && rh.draft)
              .length === 0 && (
              <div
                className="rounded border border-dark bg-primary p-1 mx-1 float-end"
                role="button"
                title="Edit Billing Rule"
                onClick={() => editExistingRule()}
              >
                <i className="fas fa-pen text-white px-1"></i>
              </div>
            )}
          {!rule.clientName && (
            <div
              className="rounded border border-dark bg-primary p-1 mx-1 float-end"
              role="button"
            >
              <i
                className="fas fa-copy text-white px-1"
                role="button"
                title="Copy to Another Payor"
                onClick={() => setCopyOpen(true)}
              ></i>
            </div>
          )}
        </div>
      </div>
      <div className="row my-2">
        <div className="col-4">
          <div className="card-safy rounded bg-light p-2">
            {rule.clientName && (
              <div className="rounded border border-dark bg-warning p-2 mb-2">
                <div className="h5">Client Name</div>
                <div className="btn btn-primary">{rule.clientName}</div>
              </div>
            )}
            <div className="h5">Payor</div>
            <div
              className="btn btn-primary mb-2"
              role="button"
              onClick={() => navigate(`/rev/payor/${rule.payorId}`)}
            >
              {rule.payorName}
            </div>
            <div className="h5">Group Plan</div>
            <div
              className="btn btn-primary mb-2"
              role="button"
              onClick={() => navigate(`/rev/payor/${rule.payorId}`)}
            >
              {rule.groupPlanName}
            </div>
          </div>
        </div>
        <div className="col-8">
          <div className="card-safy rounded bg-light p-2">
            <div className="h5">Service Configuration</div>
            <div
              className="btn btn-primary mb-2"
              role="button"
              onClick={() =>
                navigate(
                  `/rev/services/${rule.serviceConfigurationValue.serviceId}/${rule.serviceConfigurationId}`
                )
              }
            >
              {rule.serviceConfigurationName}
            </div>
            <div className="row">
              <div className="col-5">
                <div className="ms-4">
                  <div className="h5">Program Units</div>
                  {rule.serviceConfigurationValue?.programUnits?.map((pu) => (
                    <div className="text-primary fw-bold" key={pu._id}>
                      {pu.name}
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-4">
                <div className="h5">GL Code</div>
                {rule.serviceConfigurationValue?.programUnits?.map((pu) => (
                  <div className="text-danger fw-bold" key={pu._id}>
                    {pu.glCode}
                  </div>
                ))}
              </div>
              <div className="col-3">
                <div className="h5">Statuses</div>
                {rule.serviceConfigurationValue?.serviceStatuses.map((s) => (
                  <div className="text-success fw-bold" key={s}>
                    {s}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-3">
          {rule.serviceConfigurationValue?.type === "TFC" && (
            <FloatingInput
              className="border-dark"
              name="fpTiers"
              label="Foster Parent Tiers"
              value={rule.configuration?.fpTiers}
              onChange={(e) =>
                setRule({
                  ...rule,
                  configuration: {
                    ...rule.configuration,
                    fpTiers: parseInt(e.target.value),
                  },
                })
              }
              disabled={
                (rule.expiration && rule.expiration !== "") ||
                !rule.active ||
                !rule.draft
              }
            />
          )}
        </div>
        <div className="col-3">
          {/* Age Ranges
          {rule?.configuration?.ageRanges?.map((ar, index) => (
            <div
              key={index}
              className="text-primary fw-bold"
            >{`${ar.min}-${ar.max}`}</div>
          ))} */}
        </div>
        <div className="col-2">
          {/* <FloatingInput
            type="number"
            className="border-dark"
            min="0"
            max="100"
            step="1"
            name="ageMin"
            label="Age Min"
            value={rule.configuration?.ageMin}
            onChange={(e) =>
              setRule({
                ...rule,
                configuration: {
                  ...rule.configuration,
                  ageMin: parseInt(e.target.value),
                },
              })
            }
            disabled={
              (rule.expiration && rule.expiration !== "") || !rule.active
            }
          /> */}
        </div>

        <div className="col-2">
          {/* <FloatingInput
            name="ageMax"
            type="number"
            className="border-dark"
            min="0"
            max="100"
            step="1"
            label="Age Max"
            value={rule.configuration?.ageMax}
            onChange={(e) =>
              setRule({
                ...rule,
                configuration: {
                  ...rule.configuration,
                  ageMax: parseInt(e.target.value),
                },
              })
            }
            disabled={
              (rule.expiration && rule.expiration !== "") || !rule.active
            }
          /> */}
        </div>
        <div className="col-2">
          {/* {rule.active && (!rule.expiration || rule.expiration === "") && (
            <div className="btn btn-success" onClick={handleAddAgeRange}>
              Add Age Range
            </div>
          )} */}
        </div>
      </div>
      <div className="h4">Configurations</div>
      <div className="rounded border border-dark p-2">
        <div className="row">
          <div className="col-3">
            {rule?.configuration?.modalities &&
              Array.isArray(rule?.configuration?.modalities) &&
              rule.configuration?.modalities
                ?.slice()
                .sort((a, b) => {
                  const aName = a.sor_clientmodality?.name || a.name || "";
                  const bName = b.sor_clientmodality?.name || b.name || "";
                  return aName.localeCompare(bName);
                })
                .map((mod) => (
                  <div
                    className={modBorder(mod.id)}
                    key={mod.id}
                    role="button"
                    onClick={() => setData({ ...data, selected: mod })}
                  >
                    <div className="d-inline-block">{mod.name}</div>
                    {checkComplete(mod)}
                  </div>
                ))}
          </div>
          <div className="col-9">
            {data.selected && (
              <div>
                <div className="row">
                  <div className="col-10">
                    <div className="h5"> {data.selected.name}</div>
                  </div>
                  <div className="col-2"></div>
                </div>
                <div className="row">
                  <div className="col">
                    <div>Age Ranges</div>
                    <div className="">
                      {data.selected.ages.map((ar, index) => (
                        <div
                          key={index}
                          className="border border-dark btn btn-sm btn-info d-block mb-1"
                        >{`${ar.min}-${ar.max}`}</div>
                      ))}{" "}
                    </div>
                  </div>
                  <div className="col">
                    <FloatingInput
                      type="number"
                      className="border-dark"
                      min="0"
                      max="100"
                      name="ageMin"
                      label="Age Min"
                      value={data?.ageMin}
                      onChange={(e) => {
                        setData({
                          ...data,
                          ageMin: parseInt(e.target.value),
                        });
                      }}
                      onWheel={(e) => e.target.blur()}
                      disabled={
                        (rule.expiration && rule.expiration !== "") ||
                        !rule.active ||
                        !rule.draft
                      }
                    />
                  </div>
                  <div className="col">
                    <FloatingInput
                      name="ageMax"
                      type="number"
                      className="border-dark"
                      min="0"
                      max="100"
                      label="Age Max"
                      value={data?.ageMax}
                      onChange={(e) =>
                        setData({
                          ...data,
                          ageMax: parseInt(e.target.value),
                        })
                      }
                      onWheel={(e) => e.target.blur()}
                      disabled={
                        (rule.expiration && rule.expiration !== "") ||
                        !rule.active ||
                        !rule.draft
                      }
                    />
                  </div>
                  <div className="col">
                    <FloatingInput
                      type="select"
                      name="ageCalculation"
                      label="Age Calculation"
                      className="border-dark"
                      options={[
                        { _id: "First of Month", name: "First of Month" },
                        { _id: "Last of Month", name: "Last of Month" },
                        { _id: "Birthdate", name: "Birthdate" },
                      ]}
                      value={data?.ageCalculation}
                      onChange={(e) =>
                        setData({
                          ...data,
                          ageCalculation: e.target.value,
                        })
                      }
                      disabled={
                        (rule.expiration && rule.expiration !== "") ||
                        !rule.active ||
                        !rule.draft
                      }
                    />
                  </div>
                  <div className="col">
                    {rule.active &&
                      (!rule.expiration || rule.expiration === "") && (
                        <div
                          className="btn btn-success"
                          onClick={handleAddAgeRange}
                          disabled={
                            parseInt(data.ageMin) === undefined ||
                            parseInt(data.ageMax) === undefined ||
                            parseInt(data.ageMin) >= parseInt(data.ageMax)
                          }
                        >
                          Add Age Range
                        </div>
                      )}
                  </div>
                </div>
                {data.selected?.ages.map((a, index) => (
                  <div
                    className="rounded border border-dark bg-light p-2 mb-2"
                    key={`age-${index}`}
                  >
                    <div className="row mb-2">
                      <div className="col-6 h6">
                        {a.min !== ""
                          ? `Ages ${a.min} - ${a.max} calculated by: ${a.calculation}`
                          : "All Ages"}
                      </div>
                    </div>
                    <div className="row mb-4">
                      <div className="col">
                        <FloatingInput
                          name="invoiceType"
                          label="Invoice"
                          type="select"
                          options={invoices}
                          value={getValue("invoice", a)}
                          onChange={(e) =>
                            handleOnChange(e.target.value, a, "invoice")
                          }
                          disabled={
                            (rule.expiration && rule.expiration !== "") ||
                            !rule.active ||
                            !rule.draft
                          }
                        />
                      </div>
                      <div className="col">
                        {/* <FloatingInput
                          name="glCode"
                          label="GL Code Override"
                          className="border-danger text-danger"
                          value={getValue("glCode", a)}
                          onChange={(e) =>
                            handleOnChange(e.target.value, a, "glCode")
                          }
                          disabled={
                            (rule.expiration && rule.expiration !== "") ||
                            !rule.active
                          }
                        /> */}
                        <FloatingInput
                          name="billingCode"
                          label="Billing Code"
                          value={getValue("billingCode", a)}
                          onChange={(e) =>
                            handleOnChange(e.target.value, a, "billingCode")
                          }
                          disabled={
                            (rule.expiration && rule.expiration !== "") ||
                            !rule.active ||
                            !rule.draft
                          }
                        />
                      </div>
                      <div className="col">
                        <FloatingInput
                          type="select"
                          name="monthlyBilling"
                          label="Monthly Billing"
                          options={[
                            {
                              _id: "16 Days 50/100",
                              name: "16 Days 50/100",
                            },
                            {
                              _id: "15 Days 70/100",
                              name: "15 Days 70/100",
                            },
                          ]}
                          value={getValue("monthlyBilling", a)}
                          onChange={(e) =>
                            handleOnChange(e.target.value, a, "monthlyBilling")
                          }
                          disabled={
                            (rule.expiration && rule.expiration !== "") ||
                            !rule.active ||
                            !rule.draft
                          }
                        />
                      </div>
                      <div className="col">
                        <FloatingInput
                          type="select"
                          name="contra"
                          label="Contra"
                          options={[
                            { _id: "15% Always", name: "15% Always" },
                            { _id: "15% Full", name: "15% Full" },
                          ]}
                          value={getValue("contra", a)}
                          onChange={(e) =>
                            handleOnChange(e.target.value, a, "contra")
                          }
                          disabled={
                            (rule.expiration && rule.expiration !== "") ||
                            !rule.active ||
                            !rule.draft
                          }
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col h6">
                        Billing
                        <i
                          className="fas fa-circle-down text-success float-end"
                          role="button"
                          onClick={() => copyDown(a, "revenue")}
                        />
                      </div>
                      {rule.serviceConfigurationValue?.type === "TFC" &&
                        Array.from(
                          { length: rule.configuration?.fpTiers || 1 },
                          (_, i) => i + 1
                        ).map((tier, index) =>
                          tier === 1 && index === 0 ? (
                            <>
                              <div className="col h6" key={`tier-${tier}`}>
                                Maintenance
                                <i
                                  className="fas fa-circle-down text-success float-end"
                                  role="button"
                                  onClick={() => copyDown(a, `tier${tier}`)}
                                />
                              </div>
                              <div className="col"></div>
                            </>
                          ) : (
                            <>
                              <div className="col h6" key={`tier-${tier}`}>
                                <i
                                  className="fas fa-circle-down text-success float-end"
                                  role="button"
                                  onClick={() => copyDown(a, `tier${tier}`)}
                                />
                              </div>
                              <div className="col"></div>
                            </>
                          )
                        )}
                    </div>
                    {rule.serviceConfigurationValue?.serviceStatuses.map(
                      (ss) => (
                        <div className="row" key={`ss-${ss}`}>
                          <div className="col">
                            <FloatingInput
                              key={ss}
                              type="number"
                              min="0"
                              name={ss}
                              label={<span className="fw-bold">{ss}</span>}
                              value={getValue(ss, a) || ""}
                              onChange={(e) =>
                                handleOnChange(e.target.value, a, ss)
                              }
                              onBlur={(e) => handleBlur(getValue(ss, a), a, ss)}
                              onWheel={(e) => e.target.blur()}
                              stetp="any"
                              className={`border ${
                                getValue(ss, a) === "0.00" ||
                                getValue(ss, a) === ""
                                  ? "border-2 border-danger"
                                  : "border-success"
                              }`}
                              disabled={
                                (rule.expiration && rule.expiration !== "") ||
                                !rule.active ||
                                !rule.draft
                              }
                            />
                          </div>
                          {rule.serviceConfigurationValue?.type === "TFC" &&
                            Array.from(
                              { length: rule.configuration?.fpTiers || 1 },
                              (_, i) => i + 1
                            ).map((tier) => (
                              <>
                                <div className="col" key={`tier-${tier}`}>
                                  <FloatingInput
                                    key={`${ss}-tier${tier}`}
                                    type="number"
                                    min="0"
                                    name={`${ss}-tier${tier}`}
                                    label={
                                      <span className="fw-bold">{`${ss} Tier ${tier}`}</span>
                                    }
                                    value={
                                      getValue(`${ss}-tier${tier}`, a) || ""
                                    }
                                    onChange={(e) =>
                                      handleOnChange(
                                        e.target.value,
                                        a,
                                        `${ss}-tier${tier}`
                                      )
                                    }
                                    onBlur={(e) =>
                                      handleBlur(
                                        getValue(`${ss}-tier${tier}`, a),
                                        a,
                                        `${ss}-tier${tier}`
                                      )
                                    }
                                    onWheel={(e) => e.target.blur()}
                                    className={`border ${
                                      getValue(`${ss}-tier${tier}`, a) ===
                                        "0.00" ||
                                      getValue(`${ss}-tier${tier}`, a) === ""
                                        ? "border-2 border-danger"
                                        : "border-success"
                                    }`}
                                    disabled={
                                      (rule.expiration &&
                                        rule.expiration !== "") ||
                                      !rule.active ||
                                      !rule.draft
                                    }
                                  />
                                </div>
                                <div className="col">
                                  <div>Admin</div>
                                  <div>
                                    {(
                                      (getValue(ss, a) || 0) -
                                      (getValue(`${ss}-tier${tier}`, a) || 0)
                                    ).toFixed(2)}
                                  </div>
                                </div>
                              </>
                            ))}
                        </div>
                      )
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="float-end mt-4">
        {rule.published === false && (
          <div className="btn btn-success mx-4" onClick={() => handleOnSave()}>
            Save
          </div>
        )}
      </div>
    </div>
  );
}

export default CensusRule;
